import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MawUserService } from '@medappsware/maw-auth';

@Component({
    selector: 'app-check-portal',
    imports: [RouterModule],
    template: "<div>Checking...</div>",
    styleUrls: ['./../../../../node_modules/@medappsware/shared/themes/maw.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CheckPortalComponent implements OnInit {

  constructor(
    private userService: MawUserService,
    private router: Router,
  ){
    
  }

  ngOnInit(): void {
    let loggedUser = this.userService.user$;
    if(loggedUser && loggedUser.roles){
      this.setRedirects(loggedUser.roles);
    }
  }

  setRedirects(role: any) {
    if (role && role.length > 0) {
      switch (role[0].name) {
        case 'super_admin': {
          this.router.navigate(['/admin/portal']);
          break;
        }
        case 'assistant_admin': {
          this.router.navigate(['/admin/portal']);
          break;
        }
        case 'tech_admin': {
          this.router.navigate(['/admin/portal']);
          break;
        }
        default: {
          this.router.navigate(['/organizations/documents/my-documents']);
          break;
        }
      }
    }else{
      this.router.navigate(['/']);
    }
  }
}